module.exports = __webpack_public_path__ + "img/scb.9e2865c8.png";